import { Component, OnInit } from "@angular/core";
import { BaseComponent } from "../shared/base.component";
import { UiStateService } from "../core/services/ui-state-service";
import { takeUntil } from "rxjs/internal/operators";
import { combineLatest } from "rxjs";
import {
  SluitpotDto,
  BestellingSluitpotDto,
} from "../shared/api-models/models";
import { BackendService } from "../core/services/backend.service";
import { FormControl } from "@angular/forms";
import { SluitpotModel, SluitpotUtils } from "../shared/models/sluitpot.model";
import { TooltipService } from "../core/services/tooltip.service";

@Component({
  selector: "luv-sluitpotten",
  templateUrl: "./sluitpot-horiz.component.html",
  styleUrls: ["./sluitpot.component.scss"],
})
export class SluitpotComponent extends BaseComponent implements OnInit {
  private _aantalSluitpotten: number = 0;

  public sluitpottenModels: SluitpotModel[] = [];
  public validate: boolean = false;

  public sluitpotten: SluitpotDto[] = [];
  public get aantalSluitpotten(): number {
    return this._aantalSluitpotten;
  }

  constructor(
    private uiStateService: UiStateService,
    private backendService: BackendService,
    public tooltip: TooltipService
  ) {
    super();
  }

  public ngOnInit() {
    const dorpel = this.uiStateService.currentDorpel;
    combineLatest([
      this.backendService.getSluitpotten(),
      this.uiStateService.sluitpottenCount$,
      this.uiStateService.dorpelCode$
    ])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([sluitpotten, count, dorpelCodeValue]) => {
        this.sluitpotten = sluitpotten.filter(dto => dto.dorpelCode === dorpelCodeValue);
        this.sluitpottenModels = dorpel.sluitpotten.map(
          (sluitpotOrder: BestellingSluitpotDto) =>
            <SluitpotModel>{
              maat: sluitpotOrder.maat,
              // maat2: sluitpotOrder.maat2,
              sluitpotCode: sluitpotOrder.sluitpotCode || "",
              omschrijving: sluitpotOrder.omschrijving,
              isNonBlinde: SluitpotUtils.isNonBlindeSluitpott(sluitpotOrder.omschrijving)
            }
        );
        this.sluitpottenModels.forEach(model => {
          const dto = this.sluitpotten.find(item => item.sluitpotCode === model.sluitpotCode);
          if (dto) {
            model.omschrijving = dto.omschrijving;
            model.isNonBlinde = SluitpotUtils.isNonBlindeSluitpott(dto.omschrijving);
          }
        });
      });
  }

  public getSluitpotModels(): SluitpotModel[] {
    this.sluitpottenModels.forEach(model => {
      const dto = this.sluitpotten.find(item => item.sluitpotCode === model.sluitpotCode);
      if (dto) {
        model.omschrijving = dto.omschrijving;
        model.isNonBlinde = SluitpotUtils.isNonBlindeSluitpott(dto.omschrijving)
      }
    });
    return this.sluitpottenModels;
  }

  public errorMessage(formControl: FormControl, key: string): string {
    if (formControl.valid) {
      return "";
    }
    const [firstError] = Object.keys(formControl.errors);
    const error = ValidationMessages[key]
      ? ValidationMessages[key][firstError]
      : null;
    return error;
  }

  public getErrorMessage(key, validation): string {
    return ValidationMessages[key][validation];
  }

  public isControlValid(formControl: FormControl): boolean {
    return formControl.invalid && (formControl.dirty || formControl.touched);
  }

  public dataIsValid(): boolean {
    this.validate = true;
    return !this.sluitpottenModels.some((s) => !s.sluitpotCode || !s.maat /*|| (s.isNonBlinde && !s.maat2)*/);
  }

  public onMaatQChanged(index: number): void {
    let model = this.sluitpottenModels[index];
    this.uiStateService.updateSluitpot(model, index);
  }

  public showQ2Tooltip(target: HTMLElement): void {
    this.tooltip.showTooltip(target, {
      customTextDescription: "Deze maat wordt vanuit de dagkant gemeten.",
      descriptionOnly: true,
    });
  }

  public hideQ2Tooltip(): void {
    this.tooltip.hideTooltip();
  }

  public onSluitpotChanged(index: number): void {
    let model = this.sluitpottenModels[index];
    let code = model.sluitpotCode;

    let omschrijving = this.sluitpotten.find(sp => sp.sluitpotCode === code).omschrijving;
    model.omschrijving = omschrijving;
    model.isNonBlinde = SluitpotUtils.isNonBlindeSluitpott(omschrijving);
    this.uiStateService.updateSluitpot(model, index);
  }
}

const ValidationMessages = {
  sluitpotCode: {
    required: "Selecteer een sluitpot",
  },
  maat: {
    required: "MaatQ is een verplicht veld.",
  },
  // maat2: {
  //   required: "Maat2Q is een verplicht veld.",
  // },
};
